import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Nav from "@/components/public/Nav";
import Footer from "@/components/public/Footer";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="min-h-screen bg-bd-ivory flex flex-col">
      <Nav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
